import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#f50057",
    },
    background: {
      default: "#f9f9f9",
    },

  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      //color: "#F83901",
      color: "transparent",
      WebkitBackgroundColor: "linear-gradient(to right, #F83901, #FCE26F)",
      background: "linear-gradient(to right, #F83901, #FCE26F)",
      //backgroundColor: "linear-gradient(to right, #F83901, #FCE26F)",
      backgroundColor: "linear-gradient(right, red, blue)",
      backgroundClip: "text",
      //"-webkit-background-clip": "text",
      //"-webkit-text-fill-color": "transparent",
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 400,
    },
  },
  components: {
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          //'&.MuiAccordion-heading': {
          //  backgroundColor: "#000000",
          //},
          //backgroundColor: "#FA8532",
          background: "linear-gradient(to right, #F83901, #FCE26F)",
          color: "#FFFFFF",
          marginBottom: "16px",
        },
        expandIconWrapper: {
          //'&.MuiAccordion-heading': {
          //  backgroundColor: "#000000",
          //},
          //backgroundColor: "#FA8532",
          color: "#FFFFFF",
        },
      }
    }
  },
});